module.exports = __webpack_public_path__ + "static/media/Product-Tageslinsen.52d2789e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Product-Tageslinsen.jpg
// module id = 224
// module chunks = 8